export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20architectural%20pattern%20with%20warm%20cream%20and%20soft%20golden%20tones%2C%20minimalist%20clean%20lines%2C%20subtle%20intersecting%20grids%20and%20arcs%2C%20modern%20engineering%20aesthetic%2C%20soft%20diffused%20lighting%2C%20elegant%20refined%20textures%2C%20no%20people%2C%20no%20text%2C%20abstract%20technology%20motif&width=1800&height=1200&seq=berengor-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50/95"></div>
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center pt-20 pb-32">
        <p className="text-sm md:text-base tracking-[0.3em] uppercase text-foreground-200/90 mb-8 font-label font-light">
          Software Engineering
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-semibold tracking-tight text-background-50 mb-8 leading-tight">
          BERENGOR LIMITED
        </h1>
        <div className="w-16 h-px bg-primary-400/60 mx-auto mb-8"></div>
        <p className="text-base md:text-lg text-foreground-200/80 max-w-2xl mx-auto font-body font-light leading-relaxed">
          A professional engineering team dedicated to designing and developing modern digital software solutions for the iOS platform and related technologies.
        </p>
      </div>
    </section>
  );
}